import * as Yup from 'yup';
import { reverseShape } from 'Helpers/index';
import { email, fullName, fullContact, addressLine, postcode } from 'Utils/validations';

const CorporateOrderFormSchema = Yup.object().shape(
  reverseShape({
    orgName: Yup.string().required(),
    addressLine1: Yup.string().required().concat(addressLine),
    addressLine2: addressLine,
    city: Yup.string().required(),
    postcode: postcode.required(),
    state: Yup.string().required(),
    country: Yup.string().required(),
    fullName: Yup.string().required().concat(fullName),
    contactNumber: Yup.object().required().concat(fullContact),
    email: Yup.string().required().concat(email),
    kitsCount: Yup.string().required(),
    onSiteScreening: Yup.string().required(),
  })
)

export default CorporateOrderFormSchema;
